import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { PermissionRoleActionTypes, PermissionRoleActions } from "../../../actionTypes/permissions/permissionRoleActionTypes";
import { getPermissionRoleListApi, setPermissionInRoleApi } from "../../requests/permissions/permissionRoleRequests";
import { getPermissionRoleList, setPermissionRoleList } from "../../../actions/permissions/permissionRoleActions";


function* getPermssionRoleListHandler(action: PermissionRoleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPermissionRoleListApi, action.payload);
    if (data.status) {
      yield put(setPermissionRoleList({permissionRoleList: data?.data, departmentId: action.payload}))
    }
    
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}


function* setPermissionInRoleHandler(action: PermissionRoleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(setPermissionInRoleApi, action.payload.data);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(getPermissionRoleList(action.payload?.departmentId)) //refetching after updating
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}



// Permission sagas
export default function* permissionRoleSaga() {
  yield takeLatest(PermissionRoleActions.GET_PERMISSION_ROLE_LIST, getPermssionRoleListHandler);
  yield takeLatest(PermissionRoleActions.SET_PERMISSION_IN_ROLE, setPermissionInRoleHandler);
}
